export default __webpack_public_path__ + "static/media/clock.683ecd5b.svg";